document.addEventListener('variant:change', function (event) {
  const newVariantId = event.detail.variant.id;
  const galleryContainer = document.querySelector('product-gallery');

  if (!galleryContainer) return;

  const url = `${window.location.pathname}?variant=${newVariantId}&view=gallery`;
console.log('[gallery] fetching:', url);
  fetch(url)
    .then(res => res.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const newGallery = tempDiv.querySelector('product-gallery');
      if (newGallery) {
        galleryContainer.replaceWith(newGallery);
      }
    })
    .catch(err => console.error('Erro ao atualizar galeria:', err));
});